import { useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { MASCOT } from "@/lib/api";
import { AdvisorChat } from "@/components/AdvisorChat";

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (pathname.startsWith("/asesor") || pathname.startsWith("/admin")) return null;
  return (
    <>
      {open && (
        <div className="fixed z-50 bottom-16 sm:bottom-24 right-4 left-4 sm:left-auto sm:w-[380px] h-[70vh] max-h-[560px] bg-white rounded-lg shadow-2xl border border-slate-200 flex flex-col overflow-hidden rise"
          data-testid="chat-widget-panel">
          <div className="bg-[#0B1D3A] text-white px-4 py-3 flex items-center gap-3">
            <img src={MASCOT} alt="" className="w-9 h-9 rounded-full object-cover object-center border-2 border-white" />
            <div className="flex-1">
              <p className="font-display text-lg font-bold leading-none">Asesor FAUNNY</p>
              <p className="text-[11px] text-blue-200">Recomendaciones con IA</p>
            </div>
            <button onClick={() => setOpen(false)} data-testid="chat-widget-close" aria-label="Cerrar"><X size={20} /></button>
          </div>
          <div className="flex-1 min-h-0"><AdvisorChat compact onNav={() => setOpen(false)} /></div>
        </div>
      )}
      <button onClick={() => setOpen(!open)} data-testid="chat-widget-toggle" aria-label="Abrir asesor"
        className="fixed z-50 bottom-3 right-3 sm:bottom-5 sm:right-4 flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white p-1 sm:pl-1.5 sm:pr-4 sm:py-1.5 rounded-full shadow-xl transition-[background-color,transform] hover:scale-105">
        <img src={MASCOT} alt="" className="w-10 h-10 sm:w-11 sm:h-11 rounded-full object-cover object-center border-2 border-white" />
        <span className="hidden sm:inline font-display font-bold text-base">¿Te ayudo?</span>
      </button>
    </>
  );
};
